export enum OptionCalculatorModel {
    BlackSholes
}
